export const DICTIONARY_API_CARRIERS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "settings/carriers",
  BASIC_INFO: "/basic-info",
};
